import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import * as actions from "actions";
import BusinessList from "components/BusinessList";
import BusinessTypes from "components/BusinessTypes";
import OverlayImage from "components/OverlayImage";
import Layout from "layout/Layout";
import ReactDOM from "react-dom";
import { shuffleArray } from "../util/generalFunction";

class CustomerBooking extends Component {
  testRef = React.createRef();

  componentDidMount() {
    this.props.changePageTitle(" Easy Salon Appointments | Vibo Vibo");
    this.props.getPageDetails();
    ReactDOM.findDOMNode(this).scrollIntoView();

  }
  componentWillUnmount() {
    this.props.setBusinessTypeId(this.props.data[0]._id);
  }

  

  handleTypeChange = (event, id) => {
    if (id == 0) {
      if(this.props.businessTypeId != id) {
        let businesseList = [];
        this.props.data.forEach(item => {
          businesseList.push(...item.businesses)
        })
        this.props.setBusinessDetails(shuffleArray(businesseList));
        this.props.setBusinessTypeId(0);
      }
    } else {
      this.props.data.forEach(item => {
        if (item._id === id) {
          this.props.setBusinessDetails(shuffleArray(item.businesses));
          this.props.setBusinessTypeId(id);
        }
      });
    }
  };

  handleBusinessChange = businessId => {
    this.props.setBusinessIds(businessId);
  };

  bookNowClicked = (businessLocationId, businessId) => {
    // this.props.setBusinessLocationIds(businessLocationId);
    // this.props.setBusinessIds(businessId);
  };

  test = () => {
    this.testRef.current.scrollIntoView();
  };

  render() {
    //
    const user = localStorage.getItem('user-data');
    if (this.props.appointmentData != "" && user) {
      this.props.history.push(this.props.appointmentData.url.split("#")[1])
    } else {
      this.props.resetContinueBookingData();
    }
    return (
      <Layout>
        <Helmet>
          <title>{this.props.pageTitle}</title>
        </Helmet>
        <OverlayImage test={this.test} />
        <div
          ref={this.testRef}
          style={{ height: "80px", marginTop: "-80px" }}
        />  
        <div id="homepage-salon-list" className="features-boxed">
          <div className="container app-site">
            <div className="intro" />
            <BusinessTypes
              businesstypes={this.props.data}
              handleTypeChange={this.handleTypeChange}
              businessTypeId={this.props.businessTypeId}
            />
            <BusinessList
              businesses={this.props.businesses}
              handleBusinessChange={this.handleBusinessChange}
              bookNowClicked={this.bookNowClicked}
              location={this.props.location.search}
            />
          </div>
        </div>
        {/* {this.props.showMessage && NotificationManager.error(alertMessage)} */}
        <NotificationContainer />
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  pageTitle: state.changeTitle.pageTitle,
  data: state.customerBooking.data,
  businesses: state.customerBooking.businesses,
  businessTypeId: state.customerBooking.businessTypeId,
  appointmentData: state.modal.appointmentData,
});

const mapDispatchToProps = dispatch => ({
  changePageTitle: payload => dispatch(actions.setTitleOfPage(payload)),
  getPageDetails: () => dispatch(actions.getCustomerBookingPage()),
  setBusinessDetails: businesses =>
    dispatch(actions.setBusinessDetail(businesses)),
  setBusinessIds: businessId => dispatch(actions.setBusinessIds(businessId)),
  setBusinessLocationIds: businessLocationId =>
    dispatch(actions.setBusinessLocationIds(businessLocationId)),
  setBusinessTypeId: businessTypeId =>
    dispatch(actions.setBusinessTypeId(businessTypeId)),
  resetContinueBookingData: () => dispatch(actions.resetContinueBookingData()),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CustomerBooking)
);



// WEBPACK FOOTER //
// ./containers/CustomerBooking.js